import {
    LOGIN_USER,
    LOGIN_SUCCESS,
    LOGOUT_USER,
    LOGOUT_USER_SUCCESS,
    SET_TOKEN
} from "./actionTypes"
import { loadState } from "../../localStorage"

const persistedState = loadState()
const initialState = persistedState ? persistedState?.Auth : {
    profile: null,
    error: null
}

const LoginReducer = (state = initialState, action) => {
    const { data } = action

    switch (action.type) {
        case LOGIN_USER:
            return {
                ...state,
                loading: true,
            }
        case LOGIN_SUCCESS:
            return {
                ...state,
                profile: data,
                loading: false,
            }
        case SET_TOKEN:
            return {
                ...state,
                token: data,
                loading: false
            }
        case LOGOUT_USER:
            state = initialState

            break
        case LOGOUT_USER_SUCCESS:
            return {
                profile: null,
                activeCompany: null,
                error: null
            }
        default:
            return { ...state }
    }
    return state
}

export default LoginReducer
